import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { metadataApi } from './metadataSlice';
import { throwErrorMessage } from 'helpers/functions/errors';
import { getOAuth2StartUrl } from 'utils/oauth';

export const metadataApiQueryErrorLogger: Middleware = () => next => (action: any) => {
    if (isRejectedWithValue(action) && action.type.startsWith(metadataApi.reducerPath)) {
        const payload = action.payload as {
            status?: number;
            originalStatus?: number;
            data?: any;
        };

        const status = payload.originalStatus || payload.status;

        switch (status) {
            case 401:
                throwErrorMessage(401, action, 'Error code: 401');
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                const endpointName = (action.meta as any)?.arg?.endpointName;
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (403) - ${endpointName}`);
                console.warn(payload);
                break;

            case 422:
                throwErrorMessage(422, action, payload.data?.errorString);
                break;

            case 503:
                throwErrorMessage(503, action, payload.data?.errorString ?? 'Service unavailable.');
                break;

            default:
                if (status !== 409) {
                    throwErrorMessage(500, action, 'Internal server error: 500');
                }
                break;
        }
    }

    return next(action);
};
